export function formatFee(fee, currency) {
  if (fee == null || fee === "") return "Fee on request";
  const n = Number(fee);
  if (n === 0) return "Free";
  if (currency === "USD") return `US$ ${n.toLocaleString("en-US")}`;
  return `₹ ${n.toLocaleString("en-IN")}`;
}

export function planBadge(plan, featured) {
  if (plan === "premium" || featured)
    return { label: "Featured University", cls: "bg-sky-100 text-sky-700 border-sky-200", star: true };
  if (plan === "standard")
    return { label: "Listed University", cls: "bg-slate-100 text-slate-600 border-slate-200", star: false };
  return { label: "Listed", cls: "bg-slate-50 text-slate-500 border-slate-200", star: false };
}

export function resolveImg(src) {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("data:") || src.startsWith("blob:")) return src;
  return `${process.env.REACT_APP_BACKEND_URL}${src}`;
}

export function initials(name) {
  return (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}
